import React, { useRef, useState, useEffect } from 'react';

const ScrollBar = ({
    scrollHeight,
    contentHeight,
    scrollArea,
    scrollContent,
    completeHideFull,
    relativeX = 0
}) => {
    const scrollBarRef = useRef(null);
    const scrollContainer = useRef(null);
    const [scrolling, setScrolling] = useState(false);

    const [relativeValues] = useState([
        { startY: 0, currentY: 0, startScrollY: 0 }
    ]);
    const [currentTop, setCurrentTop] = useState(0);
    const Svg = ({ h }) => {
        let pct = (scrollHeight / contentHeight) * 100;
        if (pct > 100) pct = 100;
        const bar = {
            width: 12,
            height: 3,
            backgroundColor: 'white',
            marginTop: 2,
            marginBottom: 1,
            marginLeft: 2,
            marginRight: 2
        };
        return pct >= 100 ? (
            <></>
        ) : (
            <div
                ref={scrollBarRef}
                className='scrollbar'
                style={{
                    backgroundColor: 'rgb(188,188,188)',
                    border: '1px solid #d7d7d7',
                    borderRadius: 4,
                    margin: 1,
                    position: 'relative',
                    cursor: 'pointer',
                    top: currentTop,
                    height: pct + '%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                }}
                onMouseUp={scrollMouseUp}
                onMouseMove={scrollMouseMove}
                onMouseDown={scrollMouseDown}
            >
                <div style={bar}></div>
                <div style={bar}></div>
                <div style={bar}></div>
            </div>
        );
    };
    // const wheelCallBack = () => {
    //     let newY = parseInt(scrollContent?.current?.style.top);
    //     if (newY < 0) newY = 0;
    //     scrollContent.current.style.top =
    //         -newY * (contentHeight / scrollHeight) + 'px';
    // };

    const scrollMouseMove = (e) => {
        if (relativeValues.scrolling) {
            relativeValues.currentY = e.clientY;

            let newY =
                relativeValues.startScrollY + e.clientY - relativeValues.startY;

            if (newY < 0) newY = 0;
            const sbrrect = scrollBarRef.current?.getBoundingClientRect();
            const containerRect =
                scrollContainer.current?.getBoundingClientRect();
            if (newY > containerRect.height - sbrrect.height - 4) {
                newY = containerRect.height - sbrrect.height - 4;
            }

            setCurrentTop(newY);
            scrollContent.current.style.top =
                -newY * (contentHeight / scrollHeight) + 'px';
            if (Math.abs(e.clientX - relativeValues.startX) > 50) {
                scrollMouseUp(e);
            }
        }
    };

    const scrollMouseDown = (e) => {
        e.preventDefault();
        relativeValues.startY = e.nativeEvent.clientY;
        relativeValues.startScrollY = currentTop;

        relativeValues.currentY = e.nativeEvent.clientY;
        relativeValues.startX = e.nativeEvent.clientX;
        relativeValues.scrolling = true;
        setScrolling(true);
    };
    const scrollMouseUp = (e) => {
        relativeValues.scrolling = false;
        setScrolling(false);
        e.preventDefault();
        e.stopPropagation();
    };
    useEffect(() => {
        if (scrolling) {
            window.addEventListener('mousemove', scrollMouseMove);
            window.addEventListener('mouseup', scrollMouseUp);
        } else {
            window.removeEventListener('mousemove', scrollMouseMove);
            window.removeEventListener('mouseup', scrollMouseUp);
        }
    }, [scrolling]);
    return (
        <div
            ref={scrollContainer}
            className='scrollcontainer'
            style={{
                height: scrollHeight - 2,
                width: 20,
                backgroundColor: 'white',
                border:
                    completeHideFull &&
                    (scrollHeight / contentHeight) * 100 >= 100
                        ? ''
                        : '1px solid #d7d7d7',
                position: 'relative',
                padding: 0,
                left: relativeX,
                top: 0
            }}
        >
            <Svg></Svg>
        </div>
    );
};

export default ScrollBar;
